import React from "react";
import DoctorsCard from "../cards/DoctorsCard";

// Style \\
import "../../assets/styles/sections/doctorsCardSection.scss";

const DoctorsCardSection = () => {
  return (
    <section className="doctorsCardSection">
      <div className="container">
        <div className="doctorsCardSection_items">
          <DoctorsCard />
          <DoctorsCard />
          <DoctorsCard />
          <DoctorsCard />
          <DoctorsCard />
          <DoctorsCard />
        </div>
      </div>
    </section>
  );
};

export default DoctorsCardSection;
